module.exports = __webpack_public_path__ + "static/media/ic_coin_payments.1f13bb9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_coin_payments.svg
// module id = 288
// module chunks = 0